<template>
    <!--
        THE SINGLE-PAGE LAYOUT: for an app — or a part of one — that has no menu because it has
        nothing to navigate between: a self-service account page, a portal, a one-screen tool.
        It is the admin shell with the sidebar taken away, not a different design: the same
        header strip, the same content column, the same surfaces.

        The header is the Topbar's strip — `h-(--ui-header-height)`, `--ui-bg-chrome`, a bottom
        hairline — carrying the brand at the left (the mark and product name the sidebar's
        brand row shows) and the light/dark toggle at the right. There is no ☰: no drawer.

        The content column is `Default.vue`'s, class for class, including `[&>*]:shrink-0`
        (read the comment there — without it the page does not scroll). The one addition is a
        centred, width-capped inner column: without a sidebar a full-width page on a desktop
        monitor stretches a form or a card across 2000px. Its children are flex items of a
        column with auto height, so nothing inside it can be squeezed.

        Routes opt in with `meta: { layout: 'Page' }` (vue-spec `structure.md`). A menu-driven
        app uses `Default.vue`, never this.
    -->
    <div class="flex flex-col h-dvh overflow-hidden">
        <header class="h-(--ui-header-height) shrink-0 flex items-center justify-between gap-3 px-4 sm:px-6 border-b border-default bg-(--ui-bg-chrome)">
            <div class="flex items-center gap-2.5 min-w-0">
                <img src="/logo.svg" alt="" class="size-6 shrink-0" >
                <span class="text-sm font-semibold text-highlighted truncate">{{ $t('brand.product_name') }} {{ $t('brand.product_line') }}</span>
            </div>

            <div class="flex items-center shrink-0 gap-1">
                <ColorModeToggle />
            </div>
        </header>

        <main class="flex flex-col gap-3 flex-1 overflow-y-auto p-3 lg:gap-6 lg:p-6 [&>*]:shrink-0">
            <div class="flex flex-col gap-3 lg:gap-6 w-full max-w-5xl mx-auto">
                <router-view />
            </div>
        </main>
    </div>
</template>

<script lang="ts" setup>
    import ColorModeToggle from '@/layouts/components/ColorModeToggle.vue'
</script>
